var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-sheet',[_c('base-grid',{attrs:{"badgeColors":_vm.badgeColors,"ids":_vm.badgeIds,"items":_vm.items,"imageUrls":_vm.imageUrls,"gridId":"js-learning-item-grid"},on:{"grid:badge:click":function($event){return _vm.$router.push({
          name: 'learningItemManager',
          params: { id: $event.id },
          query: { edit: true }
        })}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }